// import type { WProjectCustomizationPageView } from '@zola/svc-web-api-ts-client';
import { CARD_TYPE_MAP, CardType } from '../constants/cardTypes';

type PageContext = {
  bleed_bottom?: number;
  bleed_left?: number;
  bleed_right?: number;
  bleed_top?: number;
};

export type Bleed = {
  bottom: number;
  left: number;
  right: number;
  top: number;
};

/** Corresponds to cards that don't need to be cut after printing */
const CARD_TYPES_WITHOUT_BLEED: CardType[] = [
  CARD_TYPE_MAP.envelope,
  CARD_TYPE_MAP.invitationEnvelope,
  CARD_TYPE_MAP.rsvpEnvelope,
  CARD_TYPE_MAP.napkin,
];

export const cardTypeIncludesBleedInTemplate = (cardType: CardType | string | undefined) => {
  return !(cardType && CARD_TYPES_WITHOUT_BLEED.includes(cardType as CardType));
};

/** The default bleed is 9pts. While not ALWAYS the correct value, it's what we've used in the front-end for a long time. */
export const DEFAULT_CARD_BLEED = 9;

const toBleedNumber = (value: number | undefined): number => {
  return typeof value === 'number' ? value : DEFAULT_CARD_BLEED;
};

export const getCardBleed = (
  cardType: CardType | string | undefined,
  page?: PageContext
): Bleed => {
  // If page data is available, extract the bleed from it.
  if (page) {
    return {
      bottom: toBleedNumber(page.bleed_bottom),
      left: toBleedNumber(page.bleed_left),
      right: toBleedNumber(page.bleed_right),
      top: toBleedNumber(page.bleed_top),
    };
  }

  // Otherwise, fall back on the old logic & use the default bleed for cards that will be cut.
  const fallbackBleed = cardTypeIncludesBleedInTemplate(cardType) ? DEFAULT_CARD_BLEED : 0;
  return {
    bottom: fallbackBleed,
    left: fallbackBleed,
    right: fallbackBleed,
    top: fallbackBleed,
  };
};
